// extracted by mini-css-extract-plugin
export default {"paymentType":"ACHErrorModal_paymentType__4Z4P0"};